import { render, staticRenderFns } from "./pcgView.vue?vue&type=template&id=821e2494&"
import script from "./pcgView.vue?vue&type=script&lang=js&"
export * from "./pcgView.vue?vue&type=script&lang=js&"
import style0 from "./pcgView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports